import { useCallback } from 'react';
import useAnalyticsClient from '../client/use-analytics-client';

function resolveAssignmentType(props) {
  if (props.type === 'assign' && props.previouslyHadResult) {
    return 'reassign';
  }
  return props.type;
}

export default function useTracking() {
  const client = useAnalyticsClient();

  const track = useCallback(
    (name, props) => {
      if (!client) return;
      client.track(name, props);
    },
    [client]
  );

  const trackAssignmentFlowStarted = useCallback(
    (props) => {
      track('assignment.flow-started', {
        type: resolveAssignmentType(props),
        target: props.target,
        ...(props.source ? { source: props.source } : {}),
        ...(props.action ? { action: props.action } : {}),
        activity_count: props.activityCount,
        student_count: props.studentCount,
        ...(props.previouslyHadResult !== undefined
          ? { previously_had_result: props.previouslyHadResult }
          : {}),
        ...(props.previouslyHadResultCount !== undefined
          ? { previously_had_result_count: props.previouslyHadResultCount }
          : {}),
        ...(props.dueDate ? { dueDate: props.dueDate } : {})
      });
    },
    [track]
  );

  const trackAssignmentConfirmed = useCallback(
    (props) => {
      track('assignment.confirmation', {
        type: resolveAssignmentType(props),
        target: props.target,
        ...(props.source ? { source: props.source } : {}),
        ...(props.action ? { action: props.action } : {}),
        activity_count: props.activityCount,
        student_count: props.studentCount,
        ...(props.previouslyHadResult !== undefined
          ? { previously_had_result: props.previouslyHadResult }
          : {}),
        ...(props.previouslyHadResultCount !== undefined
          ? { previously_had_result_count: props.previouslyHadResultCount }
          : {}),
        duration_ms: props.durationMs
      });
    },
    [track]
  );

  const trackSwitchToOldAssign = useCallback(
    (props) => {
      track('switch.to-old-assign', {
        context: (props && props.context) || null
      });
    },
    [track]
  );

  const trackClassChanged = useCallback(() => {
    track('filter.class-changed', {});
  }, [track]);

  const trackGroupChanged = useCallback(() => {
    track('filter.group-changed', {});
  }, [track]);

  const trackTopicApplied = useCallback(
    (props) => {
      track('filter.topic-applied', { topic_count: props.topicCount });
    },
    [track]
  );

  const trackHowItWorks = useCallback(() => {
    track('ui.how-it-works', {});
  }, [track]);

  const trackViewKey = useCallback(() => {
    track('ui.view-key', {});
  }, [track]);

  const trackMenuAction = useCallback(
    (props) => {
      track('menu.action', { action: props.action });
    },
    [track]
  );

  const trackAccessChanged = useCallback(
    (props) => {
      track('access.changed', { restricted: props.restricted });
    },
    [track]
  );

  const trackActivityPreview = useCallback(
    (props) => {
      track('activity.preview', { activity_id: props.activityId });
    },
    [track]
  );

  const trackActivityTeacherNotes = useCallback(
    (props) => {
      track('activity.teacher-notes', { activity_id: props.activityId });
    },
    [track]
  );

  const trackStudentMenu = useCallback(
    (props) => {
      track('student.menu', { action: props.action });
    },
    [track]
  );

  return {
    trackAssignmentFlowStarted,
    trackAssignmentConfirmed,
    trackSwitchToOldAssign,
    trackClassChanged,
    trackGroupChanged,
    trackTopicApplied,
    trackHowItWorks,
    trackViewKey,
    trackMenuAction,
    trackAccessChanged,
    trackActivityPreview,
    trackActivityTeacherNotes,
    trackStudentMenu
  };
}



// WEBPACK FOOTER //
// ./analytics/tracking/use-tracking.js